export default __webpack_public_path__ + "static/media/proctor_illustration.6c7b46cb.svg";